import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { colors } from "@midland-industries/Styles/colors";
import * as React from "react";

export interface FooterStyles {
    page?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {};
const styles = footerStyles;

const Footer = ({ id, fields }: PageProps) => {
    const addProps = {
        ...(!fields?.isCustomHeader && styles.page),
        ...(fields?.isCustomHeader && {
            color: fields?.isCustomHeader ? colors.background : colors.primary,
            padding: 0,
        }),
    };

    return (
        <Page as="footer" isFooter={true} {...addProps}>
            <Zone contentId={id} zoneName="Content" />
            <CookiePrivacyPolicyPopup />
        </Page>
    );
};

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [
            {
                name: "isCustomHeader",
                displayName: "Custom Header",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
            },
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
